const RESET_MESSAGE = 'RESET_MESSAGE';
export function resetMessage() {
  return {
    type: RESET_MESSAGE,
  };
}

const SET_MESSAGE = 'SET_MESSAGE';
export function setMessage(title, message, onConfirm, onClose, titleColor, onCancel) {
  return {
    type: SET_MESSAGE,
    title,
    message,
    onConfirm,
    onCancel,
    titleColor,
    onClose,
  };
}

const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE';
export function setErrorMessage(error) {
  return {
    type: SET_ERROR_MESSAGE,
    error,
  };
}
const initialState = {
  message: '',
  errorMessage: '',
  title: '',
  onConfirm: undefined,
  onCancel: undefined,
  titleColor: undefined,
  onClose: undefined,
  status: '',
  errorHttpStatus: null,
};
export default function reducer(state = initialState, action) {
  const { error, type } = action;
  if (type === SET_MESSAGE) {
    return Object.assign({}, state, {
      message: action.message,
      title: action.title,
      onConfirm: action.onConfirm,
      onCancel: action.onCancel,
      titleColor: action.titleColor,
      onClose: action.onClose,
    });
  } else if (type === RESET_MESSAGE) {
    return initialState;
  } else if (error && error.httpStatus > 400) {
    return Object.assign({}, state, {
      message: error.message,
      onConfirm: undefined,
      onCancel: undefined,
      onClose: undefined,
      status: error.status,
      errorHttpStatus: error.httpStatus,
      confirmReload: error.confirmReload !== undefined ? error.confirmReload : true,
      afterHandler: error.afterHandler,
    });
  }
  return state;
}



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/containers/App/reducers/messageReducer.js
 **/